import React from "react";
import OrderList from "../../components/order/OrderList/OrderList";
// import AddSubCategory from "../../components/subCategoryes/SubCategoryForm";

function Order() {
  return (
    <div>
      {/* <OrderForm /> */}
      <OrderList />
    </div>
  );
}

export default Order;
